// The gate's code step survives a reload (Felipe's review of #123, SIL-1618). Someone who opens the code
// email in the same tab, or reloads, used to land back on the email form, and sending the address again
// inside a minute only earned "wait a minute" while they held a good code with nowhere to type it. So the
// address a code went to is kept for the tab (sessionStorage) until the code is used, the viewer picks
// another address, or an hour passes (Supabase's default code life; an older code is dead anyway).
//
// Storage can be missing or throw (private windows, blocked site data): the gate then simply starts from
// the email form, as it did before.

export const CODE_STEP_KEY = 'silvr-viewer-code-for';
export const CODE_STEP_MAX_AGE_MS = 60 * 60 * 1000;

/** The address a code was sent to in this tab, or '' when there is none (or it is too old). */
export function readCodeStep(now: number = Date.now()): string {
  try {
    const raw = sessionStorage.getItem(CODE_STEP_KEY);
    if (!raw) return '';
    const { email, at } = JSON.parse(raw);
    if (typeof email === 'string' && email && typeof at === 'number' && now - at < CODE_STEP_MAX_AGE_MS) return email;
    sessionStorage.removeItem(CODE_STEP_KEY);
  } catch {
    /* unreadable or blocked storage */
  }
  return '';
}

/** Remember the address a code was (re)sent to, or forget the step with ''. */
export function keepCodeStep(email: string, now: number = Date.now()): void {
  try {
    if (email) sessionStorage.setItem(CODE_STEP_KEY, JSON.stringify({ email, at: now }));
    else sessionStorage.removeItem(CODE_STEP_KEY);
  } catch {
    /* blocked storage: the step lasts until the page goes, as before */
  }
}
